import React from 'react';
import './About';



const AboutSection = () => {
  return (
    <section className="about-section">
      <h2 className="center">Simple is the Solution</h2>
      <div className="content-wrapper">
        <div className="text-container">
          <p>
            Occam's Razor, put simply, states: <strong>“The Simplest Solution Is Almost Always The Best.”</strong> 
            It's a problem-solving principle arguing that simplicity is better than complexity. Named after 
            14th-century logician and theologian William of Ockham, this theory has been helping many great 
            thinkers for centuries. Many industries swear by it.
          </p>
        </div>
  
      </div>
    </section>
  );
};

export default AboutSection;